import Button from '@bit/gerenciatd.unifiedcomponents.button';
import Image from '@bit/gerenciatd.unifiedcomponents.image';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';
import React, { useEffect } from 'react';
import './SectionImage.scss';

export const COMPONENT_NAME = 'section-image';

export const IMAGE_HEIGHT_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
  CENTER: 'center',
}

const SectionImage = (props) => {
  const {
    components,
  } = props;
  const { imagePosition, desktopImageHeight, skipPaddingTop = false } = components;
  let { taggingInfo } = props;
  if (!taggingInfo) {
    taggingInfo = {
      componentVariation: 'all',
      componentName: COMPONENT_NAME,
      componentProduct: '',
    };
  }
  const showImage = (elements) => {
    elements.forEach((element) => {
      if (element.isIntersecting && !element.target.classList.contains('animate')) {
        element.target.classList.add('animate');
        element.target.classList.remove('hide');
      }
    });
  };

  const observer = new IntersectionObserver(showImage, {
    threshold: 0.5,
  });

  useEffect(() => {
    const elementsHTML = document.querySelectorAll('.Servicing-section_container_logo-empresas');
    elementsHTML.forEach((elementHTML) => {
      observer.observe(elementHTML)
    })
  }, []);

  const textSection = (
    <div className="SectionImage__container__info">
      {components['TextInfo-1'] && components['TextInfo-1'].text && (
        <TextInfo
          {...components['TextInfo-1']}
          className="SectionImage__container__info__title"
        />
      )}
      {components['TextInfo-2'] && components['TextInfo-2'].text && (
        <TextInfo
          {...components['TextInfo-2']}
          className="SectionImage__container__info__subtitle"
        />
      )}

      {components.Button && (
        <Button
          {...components.Button}
          taggingInfo={{ ...taggingInfo, componentContent: 'interes' }}
        />
      )
      }
    </div>
  )

  const desktopImagePositionClass = () => {
    const preffix = 'desktopImagePosition';
    switch (desktopImageHeight) {
      case IMAGE_HEIGHT_POSITION.CENTER:
        return `${preffix}__${IMAGE_HEIGHT_POSITION.CENTER}`;
      case IMAGE_HEIGHT_POSITION.BOTTOM:
        return `${preffix}__${IMAGE_HEIGHT_POSITION.BOTTOM}`;
      case IMAGE_HEIGHT_POSITION.TOP:
      default:
        return `${preffix}__${IMAGE_HEIGHT_POSITION.TOP}`;
    }
  }

  const renderImageSection = () => {
    const hasButtonClassName = components.Button && 'hideImageAtMobile';

    return (
      <div className={`SectionImage__container__image ${hasButtonClassName} ${desktopImagePositionClass()}`}>
        <Image
          className="Servicing-section_container_logo-empresas hide"
          {...components.image}
        />
      </div>
    )
  }

  const containerClassName = () => {
    if (imagePosition && imagePosition === 'right') {
      return 'SectionImage__container SectionImage__container__rightAlign container'
    }
    return 'SectionImage__container SectionImage__container__leftAlign container'
  }


  if (components) {
    return (
      <div className="container">
        <section className={`SectionImage ${skipPaddingTop && 'skipPaddingTop'}`}>
          <div className={containerClassName()}>
            {textSection}
            {components.image && renderImageSection()}
          </div>
        </section>
      </div>

    );
  }
  return null;
};

export default SectionImage;
